import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserService } from '../../../common/user.service'
import { FeatureService } from '../../../common/feature.service'
import { PackageService } from '../../../common/package.service'
import { CreditService } from '../../../common/credit.service';
import { CountryService } from '../../../common/country.service';
import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'supplier-feature-form',
  templateUrl: './feature-form.component.html',
  styleUrls: ['./feature-form.component.css','../../../admin/admin.css'],
  providers : [ FeatureService , PackageService, CreditService, UserService, CountryService ]
})
export class SupplierFeatureFormComponent implements OnInit {

  public eventId: any;
  public event: any;
  public packageId: any;
  public features: any;
    billingStates:any;
    public freeFeatures = [];
  public users = [];
  public onSave = new EventEmitter();
  public onClose = new EventEmitter();
  public spinner: boolean = false;
  public userIndex = 0;
  public currentAnswerIds = [];
  public currentAnswerTexts = [];
  public payType = 'Card';
  public creditCard = {
   cardId : 0,
   name : '',
   number : '',
   expMonth : '',
   expYear : '',
   cvv : '',
   type : undefined,
   save : false,
   existing : true
  };
    billingAddress = {
        name : '',
        line1 : '',
        line2 : '',
        city : '',
        stateId : '',
        state : '',
        countryId : '',
        country : '',
        zipcode : '',
        sameAsUser : false
    };
    countries = [];
    states = [];
    public cards = [];
  public formChanged: boolean = false;
  public oldPrice = 0;
  public oldUserFeatures = [];
  balance=0;

  constructor(private featureService: FeatureService, private packageService: PackageService, private creditService: CreditService, private userService: UserService, private snackBar: MdSnackBar, private countryService: CountryService) { }

  ngOnInit(){
  }

  initiate(){
   this.featureService.getFeaturesWithOptions(this.eventId).subscribe(response => {
    for(var i=0;i<response.length;i++)
    for(var j=0;j<response[i].options.length;j++)
    response[i].options[j].isPrice = parseInt(response[i].options[j].isPrice);
    this.users[this.userIndex].eventUser.features = response;
    for(var i=0;i<this.users[this.userIndex].eventUser.features.length;i++)
    this.users[this.userIndex].eventUser.features[i].isMandatory = parseInt(this.users[this.userIndex].eventUser.features[i].isMandatory);
    this.packageService.getFeatureLimits({packageId:this.packageId}).subscribe(response => {
     this.freeFeatures = [];
     for(var i=0;i<response.length;i++)
     if(parseInt(response[i].free))
     this.freeFeatures.push(response[i]);
     this.assignUserFeatures(this.users[this.userIndex]);
     this.formChanged = false;
    });
   });
      this.countryService.getCountries().subscribe(response => {
          this.countries = response;
          for(var i=0;i<this.countries.length;i++)
              if(this.countries[i].name=='USA')
              {
                  this.billingAddress.countryId = this.countries[i].id;
                  this.billingCountryChanged();
              }
      });
  }

    billingSameAsUser(){
        this.spinner = true;
        if(this.billingAddress.sameAsUser)
        {
            this.billingAddress.name = this.users[0].eventUser.companyName;
            this.billingAddress.line1 = this.users[0].eventUser.addressLine1;
            this.billingAddress.line2 = this.users[0].eventUser.addressLine2;
            this.billingAddress.city = this.users[0].eventUser.city;
            this.billingAddress.stateId = this.users[0].eventUser.stateId;
            this.billingAddress.state = this.users[0].eventUser.stateName;
            this.billingAddress.countryId = this.users[0].eventUser.countryId;
            this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
                    response => {
                    this.spinner = false;
                    this.billingStates = response;
                },
                    error => {
                    this.spinner = false;
                }
            );
            this.billingAddress.country  = this.users[0].eventUser.countryName;
            this.billingAddress.zipcode = this.users[0].eventUser.zipcode;
        }
        else
        {
            this.spinner = false;
            this.billingAddress.name = '';
            this.billingAddress.line1 = '';
            this.billingAddress.line2 = '';
            this.billingAddress.city = '';
            this.billingAddress.stateId = '';
            this.billingAddress.state = '';
            this.billingAddress.countryId = '';
            this.billingAddress.country = '';
            this.billingAddress.zipcode = '';
        }
    }

    billingStateChanged(){
        for(var i=0;i<this.billingStates.length;i++)
            if(this.billingStates[i].id==this.billingAddress.stateId)
                this.billingAddress.state = this.billingStates[i].name;
    }

    billingCountryChanged(){
        this.spinner = true;
        this.countryService.getStates(this.billingAddress.countryId).subscribe(
                response => {
                this.spinner = false;
                this.billingStates = response;
            },
                error => {
                this.spinner = false;
                this.snackBar.open(error,'',{duration:4000});
            }
        );
        for(var i=0;i<this.countries.length;i++)
            if(this.countries[i].id==this.billingAddress.countryId)
                this.billingAddress.country = this.countries[i].name;
    }


    validateZip(zip,country){
        return true;
        // if(country=='Canada')
        //     var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        // else
        //     var re = /^\d{5}(-\d{4})?$/;
        // return re.test(zip);
    }

  changeFeature(){
   this.spinner = true;
   this.creditCard.type = this.cardType();
   this.userService.changeSupplierFeature({ user:this.users[this.userIndex], creditCard:this.creditCard, payType:this.payType, event:this.event,billingAddress:this.billingAddress }).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     {
      this.snackBar.open('Additional Item Updated Successfully','',{duration:4000});
      this.onSave.emit();
      this.userService.changeSupplierFeatureMail({ mailData:response.mailData }).subscribe();
     }
     else
     this.snackBar.open(response.msg,'',{duration:4000});
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
  }

  featureFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && !this.formChanged)
   flag = false;
   if(flag && this.increased())
   {
    if(this.payType=='Card' && !this.creditCard.existing)
    {
     if(flag && !this.validateDigit(this.creditCard.number,14,19))
     flag = false;
     if(flag && !this.validateDigit(this.creditCard.cvv,3,4))
     flag = false;
    if(flag && !this.billingAddress.line1)
        flag = false;
    if(flag && !this.billingAddress.city)
        flag = false;
    if(flag && !this.billingAddress.stateId)
        flag = false;
    if(flag && !this.validateZip(this.billingAddress.zipcode,this.billingAddress.country))
        flag = false;
    if(flag && !this.billingAddress.countryId)
        flag = false;
    }
    else if(this.payType=='Card' && this.creditCard.existing)
    {
     if(flag && this.creditCard.cardId<=0)
     flag = false;
    }
   }
   return flag;
  }

  cardType(){
   return this.creditService.parseCardType(this.creditCard.number);
  }

  validateDigit(num,min,max){
   return num.match("^[0-9]{"+min+","+max+"}$");
  }



  reset(){
   this.onClose.emit();
  }

  featureOptionSelected(params){
   this.formChanged = true;
   this.setFeaturePrice(params);
  }

  setFeaturePrice(params){
   params.userFeature.price = 0.00;
   for(var i=0;i<params.feature.options.length;i++)
   {
    if(params.userFeature.answerId==params.feature.options[i].id || params.feature.options[i].selected)
    {
     if(params.feature.options[i].isPrice)
     {
      if(params.feature.answerType=='Radio')
      params.userFeature.price = parseFloat(params.feature.options[i].price);
      else if(params.feature.answerType=='Check')
      params.userFeature.price += parseFloat(params.feature.options[i].price);
     }
    }
   }
  }

  isNonFreeFeature(feature){
   var flag = true;
   for(var i=0;i<this.freeFeatures.length;i++)
   if(this.freeFeatures[i].featureId==feature.id)
   {
    flag = false;
    break;
   }
   return flag;
  }

  assignUserFeatures(user){
   var usrFtr = [];
   for(var i=0;i<user.eventUser.features.length;i++)
   {
    for(var j=0;j<user.eventUser.userFeatures.length;j++)
    {
     if(user.eventUser.features[i].id==user.eventUser.userFeatures[j].featureId)
     {
      user.eventUser.userFeatures[j].free = parseInt(user.eventUser.userFeatures[j].free);
      usrFtr[i] = user.eventUser.userFeatures[j];
      break;
     }
    }
    if(j==user.eventUser.userFeatures.length)
    usrFtr[i] = {
     userId : user.userId,
     featureId : user.eventUser.features[i].id,
     transId : '123',
     price : 0.00,
     free : !this.isNonFreeFeature(user.eventUser.features[i]),
     status : true
    };
   }
   user.eventUser.userFeatures = usrFtr;
  }

  featurePrice(){
   var featurePrice = 0;
   for(var i=0;i<this.users.length;i++)
   for(var j=0;j<this.users[i].eventUser.userFeatures.length;j++)
   featurePrice += parseInt(this.users[i].eventUser.userFeatures[j].price);
   return featurePrice.toFixed(2);
  }

  featurePriceFloat(){
   return parseFloat(this.featurePrice());
  }

  increased(){
   var increased = false;
   for(var i=0;i<this.users[this.userIndex].eventUser.userFeatures.length;i++)
   {
    if(this.oldUserFeatures[this.users[this.userIndex].eventUser.userFeatures[i].id] && parseFloat(this.users[this.userIndex].eventUser.userFeatures[i].price) > parseFloat(this.oldUserFeatures[this.users[this.userIndex].eventUser.userFeatures[i].id].price))
    {
     increased = true;
     break;
    }
   }
   return increased;
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/feature-form/feature-form.component.ts